import { useState, useEffect } from "react";
import { FaTable } from "react-icons/fa";
import { tableConstants } from "./UploadTimeTableConstant";
import Table from "../../../../components/Table/Table";
import Loader from "../../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import CardHeader from "../../../../components/Card/CardHeader";
import { createUploadTimeTable, getUploadTimeTables } from "../../../../services/AppManagement/TimeTableService";
import Button from "../../../../components/Button/Button";
import { enqueueSnackbar } from "notistack";

const UploadTimeTableList = () => {
  const [data, setData] = useState([]);
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const [selectedFiles, setSelectedFiles] = useState({});
  const [timetables, setTimetables] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [loader, setLoader] = useState(false);

  async function fetchTimeTable({ selected = 0 }) {
    const session_id = localStorage.getItem('session_id');
    const page = selected + 1;
    try {
      setIsLoader(true);
      const response = await getUploadTimeTables(session_id, page);
      if (response.status === 200) {
        setData(response.data.data);
      }
    }
    catch (error) {
      console.error("API Error:", error.response);
    }
    finally {
      setIsLoader(false);
    }
  }

  useEffect(() => {
    fetchTimeTable({ selected: 0 });
  }, []);


  const uploadHandler = async (e, program_id) => {
    const file = e.target.files[0];
    if (file) {
      // Store in a state array like:
      setTimetables((prev) => {
        // Remove any existing entry for this teacher
        const filtered = prev.filter((f) => f.program_id !== program_id);
        return [...filtered, { program_id, timetableFile: file }];
      });
    }
    if (file) {
      setSelectedFiles((prev) => ({
        ...prev,
        [program_id]: file,
      }));
    }
  }

  const uploadSingleFileHandler = async (e, program_id) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      const data = timetables.find(entry => entry.program_id === program_id);
      if (data) {
        formData.append("timetables[0][program_id]", data.program_id);
        formData.append("timetables[0][timetable]", data.timetableFile);
      } else {
        enqueueSnackbar("No file selected for this program.", { variant: "warning" });
        return;
      }

      setLoader(true);
      const response = await createUploadTimeTable(formData);

      if (response.status === 200 && response.data) {
        const { success, failed } = response.data.data;

        if (success.length > 0) {
          enqueueSnackbar("Timetable uploaded successfully!", { variant: "success" });

          // Remove uploaded program from UI
          setTimetables(prev => prev.filter(entry => entry.program_id !== program_id));
          setSelectedFiles(prev => {
            const updated = { ...prev };
            delete updated[program_id];
            return updated;
          });

          fetchTimeTable({ selected: 0 });
        }

        if (failed.length > 0) {
          failed.forEach(item => {
            enqueueSnackbar(`Failed to upload timetable for Program ID ${item.program_id}: ${item.error}`, { variant: "error" });
          });
        }
      } else {
        enqueueSnackbar("Some errors occurred during upload.", { variant: "warning" });
      }
    } catch (error) {
      console.error("Upload Error:", error);
      enqueueSnackbar("Error during upload.", { variant: "error" });
    } finally {
      setLoader(false);
    }
  };



  const bulkUploadHandler = async (timetablesArray) => {
    try {
      setLoader(true);
      const formData = new FormData();
      timetablesArray.forEach((entry, index) => {
        formData.append(`timetables[${index}][program_id]`, entry.program_id);
        formData.append(`timetables[${index}][timetable]`, entry.timetableFile);
      });

      const response = await createUploadTimeTable(formData);

      if (response.status === 200 && response.data) {
        const { success, failed } = response.data.data;

        // ✅ Show overall success message
        if (success.length > 0) {
          enqueueSnackbar(`${success.length} timetables uploaded successfully!`, { variant: "success" });
        }

        // ✅ Show detailed errors for failed uploads
        if (failed.length > 0) {
          failed.forEach(item => {
            enqueueSnackbar(`Failed to upload timetable for Program ID ${item.program_id}: ${item.error}`, { variant: "error" });
          });
        }

        // ✅ Update the state: remove uploaded entries
        const uploadedProgramIds = success.map(item => parseInt(item.program_id, 10));
        setTimetables(prev => prev.filter(entry => !uploadedProgramIds.includes(entry.program_id)));
        setSelectedFiles(prev => {
          const updated = { ...prev };
          uploadedProgramIds.forEach(id => {
            delete updated[id];
          });
          return updated;
        });

        // Optionally, refresh the table
        fetchTimeTable({ selected: 0 });
      } else {
        enqueueSnackbar("Some errors occurred during upload.", { variant: "warning" });
      }
    } catch (error) {
      console.error("Bulk Upload Error:", error);
      enqueueSnackbar("Error during upload.", { variant: "error" });
    } finally {
      setLoader(false);
    }
  };



  return (
    <div className="animated">
      <div className="card">
        <CardHeader
          title="Upload Time Table List"
          icon={<FaTable />}
          button={permissions.includes('time_table.create') &&
            <Link to="/timetable/list" className="btn btn-secondary">Back</Link>
          }
        />
        <div className="card-body">
          {isLoader ? <Loader /> :
            <div className="row mt-3">
              {data && (
                <Table
                  cols={tableConstants(permissions, uploadHandler, uploadSingleFileHandler, selectedFiles)}
                  data={data}
                  hover={true}
                />
              )}
            </div>}
          <div className="d-flex justify-content-end">
            <Button
              className="btn btn-primary mt-3"
              onClick={() => bulkUploadHandler(timetables)}
              disabled={loader || timetables.length === 0}
            >
              {loader ? "Uploading..." : "Upload All"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UploadTimeTableList;
